import createModule from "../createModule"
import view from "./view"
import { getStyleAggregation, getFocusedChartLine, getDisplayAggregationToggle, getOnly, getMetricType } from "./selectors"
import { getAvailableSelectViewFactors, getCategoryItemsSubset, getOptions, getSelectedOption, getFilteredData, getFirstHistoricalExposureDate, getDrift, getSelectedFactorCategoryId, getSelectedFactorCategoryName, getAllCategoryItems, getExposure } from "./selectors/data"
import { getFileName } from "./selectors/file"
import { Creators } from "./model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { convertPositionSetType } from "helpers/compositeSecurities"
import { VIEW_TYPES } from "helpers/base"
import { getCurrency } from "modules/analyze-composite-security/selectors"
import { CONTENT_SETS_METADATA_QUERY } from "resources/content-sets"

export default createModule({
  view,
  required: ["account", "modelId", "positionSetId", "positionSetType"],
  data: [{
    resource: "compositeExposure",
    as: null,
    url: ({ positionSetType, positionSetId, modelId, driftDates, viewType, startDate, expand, contentSetId, segment, base, baseSignature }) => {
      const from = startDate < driftDates.startDate ? startDate : driftDates.startDate
      const to = driftDates.endDate

      return {
        id: `compositeExposure-${modelId}${positionSetType}${positionSetId}${from}${to}${baseSignature}${viewType}${contentSetId}${JSON.stringify(segment)}${expand}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $from: Date!, $to: Date!, $base: [PositionSetInput], $contentSetId: String) {
          model (id: $modelId) {
            simulation (positionSet: $positionSet, from: $from, to: $to, base: $base, interval: AUTO) {
              exposure (contentSetId: $contentSetId) {
                date
                factors {
                  id
                  name
                  category
                  exposure: net
                  currencyExposure
                  long
                  short
                }
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            type: convertPositionSetType(positionSetType),
            id: positionSetId,
            segment,
            expand,
          },
          from,
          to,
          contentSetId,
          base: viewType === VIEW_TYPES.ACTIVE ? [base] : undefined,
        },
      }
    },
  }, {
    ...CONTENT_SETS_METADATA_QUERY,
    as: null,
  }],
  mapStateToProps: (state, props) => ({
    data: getFilteredData(state, props),
    items: getCategoryItemsSubset(state, props),
    exposure: getExposure(state, props),
    firstDate: getFirstHistoricalExposureDate(state, props),
    drift: getDrift(state, props),
    factorCategoryId: getSelectedFactorCategoryId(state, props),
    factorCategoryName: getSelectedFactorCategoryName(state, props),
    allCategoryItems: getAllCategoryItems(state, props),
    availableSelectViewFactors: getAvailableSelectViewFactors(state, props),
    focusedChartLine: getFocusedChartLine(state),
    only: getOnly(state, props),
    fileName: getFileName(state, props),
    ...getStyleAggregation(state, props),
    displayAggregationToggle: getDisplayAggregationToggle(state, props),
    options: getOptions(state, props),
    selectedOption: getSelectedOption(state, props),
    currency: getCurrency(state, props),
    metricType: getMetricType(state, props),
  }),
  actions: {
    ...Creators,
    openDialog: DialogCreators.open,
  },
})
